import React, { Component } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { ThemeProvider } from '@mui/material/styles';
import validate from 'validate.js';
import { IdleTimerProvider } from 'react-idle-timer';

import theme from './theme';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.scss';
import validators from './common/validators';
import Routes from './Routes';
import { Chart, ArcElement } from 'chart.js';
Chart.register(ArcElement);

validate.validators = {
  ...validate.validators,
  ...validators
};

const browserHistory = createBrowserHistory();

export default class App extends Component {
  handleOnIdle = () => {
    alert('Your session has ended due to inactivity.');
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch (err) {
      console.error(err?.message);
    }
    window.location.reload();
  };

  render() {
    return (
      <ThemeProvider theme={theme}>
        <IdleTimerProvider
          timeout={1000 * 60 * 60 * 8}
          onIdle={this.handleOnIdle}
          debounce={500}
        >
          <Router history={browserHistory}>
            <Routes />
          </Router>
        </IdleTimerProvider>
      </ThemeProvider>
    );
  }
}
